import {
  bool,
  number,
  shape,
  string,
} from 'prop-types';

import event from 'fera-prop-types/storylet/event';

export default shape({
  accessCode: string,
  canGoAgain: bool.isRequired,
  currentActionsRemaining: number.isRequired,
  event: event,
  isDirectLinkingEvent: bool.isRequired,
  isLinkingEvent: bool.isRequired,
  premiumBenefitsApply: bool.isRequired,
  rootEventId: number.isRequired,
});